import { render, staticRenderFns } from "./AcceptPoliciesInterceptor.vue?vue&type=template&id=b2ce3758&scoped=true"
import script from "./AcceptPoliciesInterceptor.vue?vue&type=script&lang=ts"
export * from "./AcceptPoliciesInterceptor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ce3758",
  null
  
)

export default component.exports